import React from 'react';
import { Button, Icon } from 'antd';
import { useNavigate } from '../../router/hooks/useNavigate';
import { useLocation } from 'react-router-dom';


type Props = {
    monitoredUrls: number;
    clusterGuid: string;
};


export default function UrlClustersMonitoredUrlsCell({ monitoredUrls, clusterGuid }: Props) {
    const navigate = useNavigate();
    const location = useLocation();

    const handleViewUrlsClick = () => {
        const newSearchString = location.search.concat(`&cluster_guid=${clusterGuid}`);
        navigate('/deep-analysis/page-group', newSearchString);
    };

    return (
        <span>
            <Button
                className="view-monitored-urls"
                size="small"
                onClick={handleViewUrlsClick}
            >
                <Icon type="link" />
                {` ${monitoredUrls} URL${monitoredUrls > 1 ? 's' : ''}`}
            </Button>
        </span>
    );
}
